import { useLockbox } from '../treasury/useLockbox';
import { usePrimaryLockbox } from '../treasury/usePrimaryLockbox';

/** @category Entities and Profiles */
export function useIsMultisig(profileId?: string, lockboxId?: string) {
  const specificLockbox = useLockbox(lockboxId);
  const primaryLockbox = usePrimaryLockbox(profileId);
  if (specificLockbox) {
    return (
      specificLockbox.requiredSigners !== undefined &&
      specificLockbox.requiredSigners > 1
    );
  }
  return (
    primaryLockbox?.requiredSigners !== undefined &&
    primaryLockbox?.requiredSigners > 1
  );
}
